import { render, staticRenderFns } from "./FileConfigurationSection.vue?vue&type=template&id=00cd8a50&"
import script from "./FileConfigurationSection.vue?vue&type=script&lang=js&"
export * from "./FileConfigurationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports